/* Stylesheet */

.footer {
  height: 492px;
  background: var(--ion-gradient-dark);
  border-radius: 100% 100% 0% 0% / 10% 50% 0% 0%;
  color: white;

  .grid_container {
    height: 100%;
    width: 75%;

    .content_row {
      height: calc(100% - 72px);

      .col {
        padding: 92px 0px 0px 0px;
        display: flex;
        height: 100%;

        .call_to_action_container {
          .question {
            margin: 0px 0px 42px 0px;
            font-size: 1.313rem;
            line-height: 1.5;
            font-weight: bold;

            span {
              color: var(--ion-color-primary);
            }
          }
        }
      }

      .pages_col {
        .label {
          font-weight: bolder;
          color: #ededed;
        }
      }
    }

    .subcontent_row {
      border-top: 1px solid #3b4c65;

      .col {
        display: flex;
        align-items: center;
      }

      .copyright_col {
        font-size: 0.875rem;

        .copyright {
          color: #ffffff;
        }
      }

      .social_links_col {
        justify-content: flex-end;
      }
    }
  }
}
